import { render, staticRenderFns } from "./update.vue?vue&type=template&id=5d3e0f5b&scoped=true"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"
import style0 from "./update.vue?vue&type=style&index=0&id=5d3e0f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e0f5b",
  null
  
)

export default component.exports